export const LocationIcon = ({ className }) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_3307_29607)">
        <path
          d="M6.11603 1.61328C4.1428 1.61328 2.54688 3.2092 2.54688 5.18243C2.54688 7.8593 6.11603 11.8109 6.11603 11.8109C6.11603 11.8109 9.68518 7.8593 9.68518 5.18243C9.68518 3.2092 8.08926 1.61328 6.11603 1.61328ZM3.56663 5.18243C3.56663 3.77517 4.70876 2.63304 6.11603 2.63304C7.52329 2.63304 8.66542 3.77517 8.66542 5.18243C8.66542 6.65088 7.19697 8.84846 6.11603 10.22C5.05548 8.85866 3.56663 6.63559 3.56663 5.18243Z"
          fill="#070707"
        />
        <path
          d="M6.11845 6.45564C6.82244 6.45564 7.39314 5.88494 7.39314 5.18095C7.39314 4.47695 6.82244 3.90625 6.11845 3.90625C5.41445 3.90625 4.84375 4.47695 4.84375 5.18095C4.84375 5.88494 5.41445 6.45564 6.11845 6.45564Z"
          fill="#070707"
        />
      </g>
      <defs>
        <clipPath id="clip0_3307_29607">
          <rect
            width="12.2371"
            height="12.2371"
            fill="white"
            transform="translate(0 0.59375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
